import "./TermsAndConditions.css";
const TermsAndConditions = () => {
  return (
    <div id="termsAndConditions_container">
      <h2>Terms and Conditions</h2>
      <br />
      <p>
        These terms and conditions outline the rules and regulations for the use
        of Sri Mandeswaraswamy Temple’s Website. By using this website and its
        services provided by Sri Mandeswaraswamy Temple (referred to as the
        “Owner”), you agree to follow these Terms & Conditions (referred to as
        the “Terms of Service”). These Terms of Service include the Privacy
        Policy and apply to your use of www.snehsagarfoundation.org (referred to
        as the “Website”), all its pages, and any services offered on the
        Website (“Services”). By accessing either directly or through a
        hyperlink, the Website, and/ or purchasing something from us, you engage
        in our “Service” and agree to be bound by the Terms of Service including
        those additional terms and conditions and policies referenced herein
        and/or available by hyperlink. These Terms of Service apply to all users
        of the site, including without limitation vendors, buyers, customers,
        merchants, browsers and/ or contributors of content. You acknowledge and
        agree that the Website may use your personal information in the manner
        described in our Privacy Policy which sets forth how information
        collected about you is collected, used and stored. In these Terms of
        Service
        <br />
        <br />
        (a) Owner, Us, We: We are the ones who created, operate, and publish the
        Website. When we say “Owner,” “Us,” or “We,” we’re referring to In these
        Terms of Service and all our employees and affiliates.
        <br />
        (b) You, the User, the Client: You are the person using the Website.
        Throughout these Terms of Service, we’ll refer to you as “You,” “Your,”
        or “User.” “User” or “you” means anyone accessing the Website.
        <br />
        (c) Parties: Together, we are the Parties to these Terms of Service –
        that means both the Owner and You.
        <br />
        <br />
        <h5>License & Disclaimer</h5>
        <br />
        By using the Website, You warrant that You have read and reviewed these
        Terms of Service and that You agree to be bound by it. If You do not
        agree to be bound by these Terms of Service, please leave the Website
        immediately. The Owner only agrees to provide use of this Website and
        Services to You if You assent to these Terms of Service. Further, based
        on the Services obtained by a User, additional terms and conditions in
        respect of the specific Services may apply, which shall be deemed an
        agreement between the Users and the Owner. By using the Website, you
        confirm that you have read and understood these Terms of Service, and
        you agree to abide by them. If you do not agree with these Terms of
        Service, please exit the Website immediately. The Owner provides access
        to this Website and its Services only if you agree to these Terms of
        Service. Additionally, depending on the Services you use, there may be
        additional terms and conditions that apply, forming an agreement between
        you and the Owner. By using the Website and its Services, you
        acknowledge that they belong to the Owner and are protected by
        copyrights, trademarks, patents, and other intellectual property rights
        (“Owner IP”). You agree that the Owner exclusively owns all rights to
        the Owner IP and you will not use it unlawfully or in a way that
        infringes on these rights. You also agree not to copy or distribute the
        Owner IP in any form, including electronically or by registering new
        trademarks, trade names, or URLs, without the Owner’s written
        permission.
        <br />
        <br />
        <h5>Payment & Fees</h5>
        <br />
        If you sign up for any paid Services or buy any product on this website,
        you agree to pay the specified amount for that product or service. These
        amounts, called “Fees,” will be clearly outlined during your account
        setup or checkout process. The total amount due will be displayed to you
        before you make the purchase. We have the right to decline service or
        refuse to sell products on the Website to anyone, at any time, and for
        any reason, solely at our discretion. Permissible Utilization
        <br />
        You agree not to use the Website or Services for any illegal activities
        or activities prohibited by these terms. You also agree not to use the
        Website or Services in a way that could harm the Website, Services, or
        the Owner’s business. You agree not to use the Website or Services to:
        <br />
        (1) Harass, threaten, or abuse others, or violate anyone’s legal rights.
        <br />
        (2) Infringe on the Owner’s or any third party’s intellectual property
        rights.
        <br />
        (3) Spread computer viruses or other harmful software that could damage
        someone else’s property.
        <br />
        (4) Commit fraud.
        <br />
        (5) Participate in illegal gambling, sweepstakes, or pyramid schemes.
        <br />
        (6) Share obscene or defamatory material.
        <br />
        (7) Promote violence, hate, or discrimination against any group.
        <br />
        (8) Illegally collect information about others.
        <br />
        You are not allowed to use the site or its content:
        <br />
        (a) for any illegal activities.
        <br />
        (b) to encourage others to participate in illegal activities.
        <br />
        (c) to violate anyone’s intellectual property rights, privacy, or
        publicity rights, whether you’re aware of it or not.
        <br />
        (d) to break any local, national, or international laws.
        <br />
        (e) to harm, insult, or discriminate against others based on factors
        like gender, religion, race, or disability.
        <br />
        (f) to share false or harmful information, or any content that is
        defamatory, threatening, abusive, indecent, obscene, or exploitative.
        <br />
        (g) to upload viruses or any other harmful code that could disrupt the
        Website or other users’ experience.
        <br />
        (h) to collect personal information from others without their consent.
        <br />
        (i) to harm or disable the Website or anyone else’s ability to use it.
        <br />
        (j) to engage in spamming, phishing, or other malicious activities.
        <br />
        (k) for any immoral or indecent purposes.
        <br />
        (l) to bypass or interfere with the Website’s security features.
        <br />
        (m) to threaten or harass other users.
        <br />
        We reserve the right to terminate your access to the Service or the
        Website if you violate any of these rules. We also have the authority to
        review all content posted by users on the Website. You understand that
        we are not responsible for the content posted by users, and you agree
        not to upload any content that you don’t have the right to share, such
        as someone else’s intellectual property. You agree to follow all
        relevant laws and regulations when using the Website. You also agree not
        to share any information or materials that are abusive, intrusive of
        someone else’s privacy, harassing, defamatory, vulgar, obscene, or
        otherwise objectionable. This includes content that could encourage
        illegal behavior or violate any laws or regulations. While we have the
        right to monitor and edit content, we are not obligated to do so.
        However, we may remove content that we believe, in our sole discretion,
        is unlawful, offensive, threatening, defamatory, or violates anyone’s
        intellectual property rights or these Terms of Service. You are not
        allowed to use our products for any illegal purposes, and you must
        comply with all laws in your jurisdiction, including copyright laws,
        when using the Service.
        <br />
        <br />
        <h5>Privacy Information</h5>
        <br />
        When you use the Website and Services, you may provide us with certain
        information. By using the Website or Services, you give us permission to
        use your information in India and any other country where we operate.
        <br />
        (a) Information We Collect: When you register for an account, you
        provide us with your email address and may also give us additional
        information like your name or billing details. Depending on how you use
        our Website or Services, we may also get information from external
        applications you use to access our Website, or through various web
        technologies like cookies, log files, or web beacons.
        <br />
        (b) How We Use Your Information: We use the information we gather from
        you to ensure you have a good experience on our website, including
        through email communication. We may also analyze certain passive
        information to improve our marketing and analytics, sometimes working
        with third-party providers.
        <br />
        (c) Protecting Your Information: If you want to stop us from getting
        passive information through various technologies, you can disable
        cookies in your web browser. However, please note that we will still
        receive information you provide directly, like your email address. If
        you decide to close your account, we will still keep certain information
        about you.
        <br />
        <br />
        <h5>Data Loss</h5>
        <br />
        The Owner does not accept responsibility for the security of Your
        account or content. You agree that Your use of the Website or Services
        is at Your own risk.
        <br />
        <br />
        <h5>Defense and Compensation</h5>
        <br />
        You agree to protect and compensate the Owner and any affiliates (if
        applicable), and not hold us responsible for any legal claims or
        demands, including reasonable lawyer fees, that arise from your use or
        misuse of the Website or Services, your violation of these Terms of
        Service, or your behavior. You agree that the Owner can choose its own
        legal representation and may be involved in its own defense, if it
        decides to do so.
        <br />
        <br />
        <h5>Spam Policy</h5>
        <br />
        You are strictly prohibited from using the Website or any of the Owner’s
        Services for illegal spam activities, including gathering email
        addresses and personal information from others or sending any mass
        commercial emails.
        <br />
        <br />
        <h5>Removal of links from our website</h5>
        <br />
        If you find any link on our Trust Website that is offensive for any
        reason, you are free to contact and inform us any moment. We will
        consider requests to remove links but we are not obligated to or so or
        to respond to you directly. We do not ensure that the information on
        this website is correct, we do not warrant its completeness or accuracy;
        nor do we promise to ensure that the website remains available or that
        the material on the website is kept up to date.
        <br />
        <br />
        <h5>Alteration and Divergence</h5>
        <br />
        The Owner reserves the right to change these Terms of Service at any
        time without notifying you. You agree that the Owner can modify these
        Terms of Service or make any revisions as needed. Any modifications to
        these Terms of Service will take effect immediately once they are posted
        on the Website, and they will replace any previous versions unless
        otherwise specified.
        <br />
        (a) If any part of these Terms of Service is found to be invalid by a
        court of law, the previous version of the Terms of Service will still be
        considered valid to the fullest extent.
        <br />
        (b) You agree to check these Terms of Service regularly and to note any
        modifications or variations by referring to the Effective Date at the
        top of the page. Make sure to clear your cache to ensure you’re viewing
        the most recent version of the Terms of Service. Your continued use of
        the Website after any modifications indicates your acceptance of the
        updated Terms of Service.
        <br />
        (c) If you fail to monitor any changes to these Terms of Service, you
        agree that it will be considered as your acceptance of the modified
        Terms of Service.
        <br />
        <br />
        <h5>Complete Agreement</h5>
        <br />
        This Agreement represents the complete agreement between the Parties
        regarding the use of this Website, replacing all prior agreements,
        whether written or oral, regarding the same matter.
        <br />
        <br />
        <h5>Service Disruptions</h5>
        <br />
        The Owner may need to temporarily halt your access to the Website for
        maintenance or emergency purposes, whether planned or unexpected. You
        understand that your access may be affected by downtime, but the Owner
        is not liable for any damage or loss caused by such interruptions.
        <br />
        <br />
        <h5>Duration, Conclusion & Halting</h5>
        <br />
        The Owner reserves the right to terminate these Terms of Service with
        you at any time, for any reason, with or without cause. This includes
        violations of the terms outlined in this agreement, such as infringing
        on intellectual property rights, failing to comply with laws, or
        distributing illegal material. If you have an account with us, you can
        also terminate these Terms of Service by contacting us. Any outstanding
        fees will still be due after termination. Certain provisions of these
        Terms of Service will remain in effect even after termination.
        <br />
        <br />
        <h5>Warranties</h5>
        <br />
        Your use of the Website and Services is solely at your own risk. We
        provide Services on an “As Is” basis and explicitly disclaim all express
        or implied warranties, including fitness for a particular purpose and
        merchantability. We do not guarantee that the Website or Services will
        meet your needs or operate without interruptions, errors, or security
        issues. We also do not guarantee the reliability or accuracy of any
        information on the Website or obtained through Services. Any damage to
        your computer system or loss of data resulting from your use of the
        Website or Services is your responsibility, and we are not liable for
        such damage or loss. All information, software, products, services, and
        related graphics provided on this site are provided “as is” and “as
        available” without any warranties, express or implied. We do not
        guarantee the suitability, accuracy, or reliability of the information,
        products, or services offered on this Website. We do not warrant that
        the Website will be uninterrupted, secure, or error-free. Your use of
        any information or materials on this site is entirely at your own risk.
        We are not responsible for the accuracy, currency, completeness, or
        usefulness of any information, views, opinions, or advice on the
        Website. We do not control or endorse any third-party content on the
        Website. We have no liability for any interactions between you and other
        users of the Website or any third parties. You release us from any
        claims, demands, or damages arising from such disputes. While we have
        made efforts to safeguard the Website, we cannot guarantee that it is
        immune to unauthorized access by third parties. We are not liable for
        any unauthorized access to your information or any resulting damages. We
        are not responsible for any threatening, defamatory, or illegal content
        posted by third parties. We have no liability for delays, cancellations,
        or other events beyond our control. You are solely responsible for any
        damages to your computer system or loss of data resulting from
        downloading information from the Website. We are not liable for any
        damages, including loss of use, data, or profits, arising from your use
        of the Website. Our liability for any loss or damage arising from your
        use of the Website will not exceed 50% of the amount you paid to us for
        the transaction in question. You agree to indemnify and hold us harmless
        from any actions taken by you or authorized users of your account. By
        using the Website, you agree to defend and indemnify us from any
        liability arising from your use of the site or participation in any site
        activities. If you are dissatisfied with the Website or Services, your
        only recourse is to stop using the site.
        <br />
        <br />
        <h5>Limitation on Liability</h5>
        <br />
        The Owner is not responsible for any damages resulting from your use of
        the Website or Services, to the fullest extent permitted by law. Our
        maximum liability under these Terms of Service is limited to the lesser
        of Rs. 1000 (Rupees One Thousand only) or the amount you paid to us in
        the last six (6) months. This limitation applies to all claims against
        us, including lost profits, consequential damages, negligence, fraud, or
        any other type of claim.
        <br />
        <br />
        <h5>General Provisions:</h5>
        <br />
        Language: All communications and notices concerning these Terms of
        Service must be in English.
        <br />
        Jurisdiction, Venue & Governing Law: Your usage of the Website or
        Services indicates your agreement that any disputes arising from these
        Terms of Service shall be governed by Indian law. Legal proceedings
        permitted under these Terms of Service must be exclusively initiated in
        the courts at New Delhi, India. You waive any objections to this
        selection of law and jurisdiction. Assignment: You are not permitted to
        transfer your rights or obligations under these Terms of Service. In the
        event of a transfer of these Terms of Service by the Owner, the new
        owner will assume all associated rights and obligations. Severability:
        If any part of these Terms of Service is found to be invalid, the
        remaining provisions will continue to apply to the fullest extent
        permitted by law. No Waiver: Failure to enforce any provision of these
        Terms of Service does not constitute a waiver of our right to enforce
        that provision in the future. Headings for Convenience Only: Headings
        within these Terms of Service are provided for organizational purposes
        and do not alter the meaning of the provisions. No Agency, Partnership,
        or Joint Venture: These Terms of Service do not establish any agency,
        partnership, or joint venture between the parties. Force Majeure: We are
        not liable for any failure to perform due to circumstances beyond our
        control, such as natural disasters.
        <br />
        Need help? Contact us at aceomandapalli@gmail.com for questions related
        to refunds and returns.
      </p>
    </div>
  );
};
export default TermsAndConditions;
